const message = {
  isRequired: (name: string) => `${name} is required`,
  mustBeNumber: (name: string) => `${name} must be a number`,
  pleaseSelect: (name: string) => `Please select ${name}`,
  invalidDateFormat: "Invalid date format, please enter a date in the format DD.MM.YYYY",
};

export default message;
